import { render, staticRenderFns } from "./SetupFiltering.vue?vue&type=template&id=4d5695ef&scoped=true&"
import script from "./SetupFiltering.vue?vue&type=script&lang=js&"
export * from "./SetupFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5695ef",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d5695ef')) {
      api.createRecord('4d5695ef', component.options)
    } else {
      api.reload('4d5695ef', component.options)
    }
    module.hot.accept("./SetupFiltering.vue?vue&type=template&id=4d5695ef&scoped=true&", function () {
      api.rerender('4d5695ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/setup/SetupFiltering.vue"
export default component.exports